export default __webpack_public_path__ + "static/media/section1-bg1.abc45c4d.png";